import React from 'react';
import { FormFieldRadio as IFormFieldRadio } from '@publishing-engine/domain/types/article';
import { Flex, Text } from '@chakra-ui/react';
import { RadioGroup } from '../RadioGroup';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { parseStringWithLinks } from 'src/utils/parseStringWithLinks';
import { IRoleType } from '@publishing-engine/domain/models';
import FormFieldErrorMessage from './common/FormFieldErrorMessage';

interface IFormFieldRadioProps {
  config: IFormFieldRadio;
  roleType?: IRoleType;
  isEditingAllowed?: boolean;
}

const FormFieldRadioGroup: React.FC<IFormFieldRadioProps> = ({
  config,
  roleType,
  isEditingAllowed = true
}) => {
  const { control } = useFormContext();
  const {
    params: { labels, validations },
    caseDataFields: { main: field }
  } = config;

  const optionKeys = validations.options;

  const options = optionKeys.map(key => {
    return {
      value: key,
      children: (
        <Flex flexDirection="column">
          <Text textStyle="headingItem">
            {labels.options[key]?.main &&
              parseStringWithLinks(labels.options[key]?.main)}
          </Text>
          <Text textStyle="textBody">
            {labels.options[key]?.secondary &&
              parseStringWithLinks(labels.options[key]?.secondary)}
          </Text>
        </Flex>
      )
    };
  });

  const getLabel = (): string => {
    const defaultLabel = labels.main;
    if (roleType) {
      return labels.input?.[roleType] ?? defaultLabel;
    }

    return defaultLabel;
  };

  return (
    <Flex flexDirection="column" gap={6}>
      <FieldLabel
        isRequired={validations.required}
        label={getLabel()}
        subText={labels.subtitle}
        helpText={labels.helpText}
      />
      <Flex flexDirection="column">
        <RadioGroup
          name={field}
          control={control}
          options={options}
          required={validations.required}
          gap={4}
          isEditingAllowed={isEditingAllowed}
        />
      </Flex>
      <FormFieldErrorMessage config={config} />
    </Flex>
  );
};

export default FormFieldRadioGroup;
